import React, {useEffect, useState} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
import Button from "../Buttons/Button";
import { BtnWrap, HeaderBody, HeaderInner, HeaderWrap, ProfileInfo, ProfileInfoMobile } from './Header.styles';
import mainLogo from '../../assets/logo/logo-light-md.png';
import profileImg from "../../assets/img/profile.png"
import burgerMenu from '../../assets/icons/burger_menu.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectUser } from '../../app/features/user/userSlice';
import {getUserMe} from "../../app/features/user/userActions";

function Header() {
    const {userInfo} = useSelector(selectUser)
    const dispatch = useDispatch()
    const navigate=useNavigate();
    const { pathname } = useLocation();


    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);


    const toggleDropdown = (id) => {
        setActiveDropdown(activeDropdown === id ? null : id);
    };

    const handleLinkClick = (id, dropdown) => {
        if (dropdown) {
            toggleDropdown(id);
        } else {
            setActiveDropdown(null);
        }
    };

    // Close the dropdown and the mobile menu whenever the page changes.
    useEffect(() => {
        setActiveDropdown(null);
        setIsBurgerMenuOpen(false);
    }, [pathname]);

    return (
        <HeaderWrap>
            <div className="main-container">
                <HeaderInner>
                    <div>
                        <Link to="/" onClick={()=>setActiveDropdown(null)}>
                            <img src={mainLogo} alt="logo" className="main-logo" />
                        </Link>
                    </div>
                    <HeaderBody>
                        {userInfo?.id ?
                            <Navbar activeDropdown={activeDropdown} handleLinkClick={handleLinkClick}/> :<div></div>
                        }
                        <BtnWrap>
                            {!userInfo ? (
                                <>
                                    <Link to="/sign-in">
                                        <Button btnClassName={"sign-in"} btnText="Sign In" />
                                    </Link>
                                    <Link to="/sign-up">
                                        <Button btnText="Sign Up" />
                                    </Link>
                                </>
                            ) : (
                                <>
                                    <ProfileInfo>
                                        <Link to={"/profile/info"}>
                                            <img
                                                src={profileImg}
                                                alt="profile"
                                                width={22}
                                                height={22}
                                            />
                                            {userInfo?.first_name && (
                                                <p>Hi, {userInfo?.first_name}</p>
                                            )}
                                        </Link>
                                        <Button
                                            btnText="Logout"
                                            onBtnClick={() => {
                                                dispatch(logout());
                                                navigate('/')
                                            }}
                                        />
                                    </ProfileInfo>
                                </>
                            )}
                        </BtnWrap>
                    </HeaderBody>
                    <div className="burger-menu" onClick={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}>
                        <img className={"burger"} src={burgerMenu} alt={"burger icon"}/>
                    </div>
                    {isBurgerMenuOpen && <div className={"burger-opened-menu"}>
                        {userInfo?.id ?
                            <Navbar activeDropdown={activeDropdown} handleLinkClick={handleLinkClick}/> :<div></div>
                        }
                        <BtnWrap>
                            {!userInfo ? (
                                <>
                                    <Link to="/sign-in">
                                        <Button btnClassName={"sign-in"} btnText="Sign In" />
                                    </Link>
                                    <Link to="/sign-up">
                                        <Button btnText="Sign Up" />
                                    </Link>
                                </>
                            ) : (
                                <>
                                    <ProfileInfoMobile>
                                        <Link to={"/profile/info"}>
                                            <img
                                                src={profileImg}
                                                alt="profile"
                                                width={22}
                                                height={22}
                                            />
                                            {userInfo?.first_name && (
                                                <p>Hi, {userInfo?.first_name}</p>
                                            )}
                                        </Link>
                                        <Button
                                            btnText="Logout"
                                            onBtnClick={() => {
                                                dispatch(logout());
                                                navigate('/')
                                            }}
                                        />
                                    </ProfileInfoMobile>
                                </>
                            )}
                        </BtnWrap>
                      </div> }
                </HeaderInner>
            </div>
            <div style={{backgroundColor:"#F15A24", height:"6px"}}/>
        </HeaderWrap>
    );
}

export default Header;

